/* =========================================================================
   PG Design Studio · post-sign-in return bounce
   Reads a sessionStorage flag (`ds:pending-resume`) set by the studio's
   save-prompt right BEFORE the customer was redirected to `/account/login`.
   If the customer is now signed in (per Liquid `{% if customer %}`, written
   to `window.__pgCustomerSignedIn` by theme.liquid) AND the flag is fresh
   (set < 15 min ago), bounces them back to the product page with the
   restoration params the widget understands.
   This sidesteps Shopify's broken `return_to` flow — we own the storefront
   side of the redirect chain entirely.
   ========================================================================= */
(function () {
  try {
    if (typeof window === "undefined") return;
    if (!window.__pgCustomerSignedIn) return;
    var raw = sessionStorage.getItem("ds:pending-resume");
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw); } catch { return; }
    if (!data || !data.handle) return;

    // Self-expire after 15 minutes — a customer who closed the tab and
    // came back hours later shouldn't be hijacked into a redirect.
    if (typeof data.setAt === "number" && Date.now() - data.setAt > 15 * 60 * 1000) {
      sessionStorage.removeItem("ds:pending-resume");
      return;
    }

    // Consume the flag immediately so we never loop (even if the redirect
    // somehow lands back on this script before it tears down).
    sessionStorage.removeItem("ds:pending-resume");

    var target = "/products/" + encodeURIComponent(data.handle) + "?ds_just_signed_in=1";
    if (data.anonymousId) {
      target += "&ds_claim=" + encodeURIComponent(data.anonymousId);
    }
    // Avoid the bounce when we're already at the target — prevents an
    // infinite loop edge case if Shopify ever lands us at the same URL.
    var here = window.location.pathname + window.location.search;
    if (here.indexOf("/products/" + data.handle) === 0 && /ds_just_signed_in=1/.test(here)) {
      return;
    }
    window.location.replace(target);
  } catch (_e) { /* never disrupt the page */ }
})();
